import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, MessageCircle } from "lucide-react";
import { Logo } from "../Logo";
import { DOWNLOADS_WA_LINK } from "./constants";

export const DownloadsHeader = () => (
  <header className="sticky top-0 z-40 backdrop-blur-md bg-ink/80 border-b border-white/5">
    <div className="max-w-[1500px] mx-auto px-6 py-3 flex items-center justify-between">
      <Link to="/" className="flex items-center gap-2 group">
        <ArrowLeft className="w-4 h-4 text-white/60 group-hover:text-white transition" />
        <Logo variant="horizontal" className="h-8 sm:h-11 max-w-none" testId="downloads-logo" />
      </Link>
      <a
        href={DOWNLOADS_WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#25D366] hover:brightness-110 text-white text-sm font-semibold transition"
      >
        <MessageCircle className="w-4 h-4" /> <span className="hidden sm:inline">Suporte</span>
      </a>
    </div>
  </header>
);

const HERO_BG = {
  backgroundImage:
    "linear-gradient(180deg, rgba(2,8,23,0.6) 0%, rgba(2,8,23,0.98) 90%), url(https://images.unsplash.com/photo-1574375927938-d5a98e8ffe85?w=1600)",
  backgroundSize: "cover",
  backgroundPosition: "center",
  filter: "blur(8px)",
  transform: "scale(1.05)",
};

export const DownloadsHero = () => (
  <section className="relative overflow-hidden">
    <div className="absolute inset-0 -z-10" style={HERO_BG} />
    <div className="max-w-[1500px] mx-auto px-6 py-12 md:py-16 text-center">
      <Logo className="h-36 md:h-48 mx-auto mb-6" testId="downloads-hero-logo" />
      <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight">
        Baixe o <span className="brand-gradient-text">MasterX HD</span>
      </h1>
      <p className="mt-3 text-white/65 max-w-2xl mx-auto">
        Disponível na Google Play, APK direto, Windows e iPhone. Após instalar, faça login com o usuário e senha enviados via WhatsApp.
      </p>
    </div>
  </section>
);
